import getApi from '../../api'
import { Survey, SurveyApi } from '../../model/Survey'

export const duplicateSurvey = (survey: SurveyApi) => getApi().post<Survey>('/surveys', survey)
